import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Covid19Reopening} from './covid-19-reopening';

@Injectable()
export class Covid19ReopeningService {
  constructor(private http: HttpClient) {
  }

  public save(reopening: Covid19Reopening): Observable<any> {
    return this.http.put('oc-api/operations/covid19/merchants-opening', reopening);
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/reopening/covid-19-reopening.service.ts